<template>
  <van-popup
    v-model:show="popupVisible"
    position="center"
    :overlay-style="{ backgroundColor: '#00000088' }"
    round
    :style="{ background: '#ffffff00' }"
  >
    <div
      class="relative flex items-center justify-center rounded-sm p-4"
      @click.self="channelStore.hideAdPopup()"
    >
      <img
        src="@/assets/images/index/ad-qrcode.jpg"
        alt="二维码"
        class="w-[90%] object-contain"
        v-on-long-press="longPress"
      />
    </div>
  </van-popup>
</template>

<script setup lang="ts">
import { useChannelStore } from '@/stores'
import YouMeng from '@/utils/YouMeng'
import { vOnLongPress } from '@vueuse/components'

const channelStore = useChannelStore()
const popupVisible = computed({
  get: () => channelStore.adPopupVisible,
  set: (val) => {
    if (val) {
      channelStore.showAdPopup()
    } else {
      channelStore.hideAdPopup()
    }
  },
})

const longPress = () => {
  YouMeng.pushRecord({}, 'gzcmc.xhc.h5.enroll.data.qr', 'longpress')
}
</script>
